import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { IIceEntity } from 'projects/icemedx-lib/src/models/core/IceEntity';

import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';

import {
  IcecontrolSettings,
  iceColumnDefinition,
} from 'projects/icemedx-lib/src/components/models/icesettings';

import { PhrBaseListView } from '../phrbaselistview.component';
import { userTypes } from 'projects/icemedx-lib/src/login/login.config';
import { MessageService } from 'projects/icemedx-lib/src/services/message/message.service';

@Component({
  selector: 'app-phrdocuments',
  templateUrl: './phrdocuments.component.html',
  styleUrls: ['./phrdocuments.component.scss'],
  providers: [AppService, IceNavService]
})
export class PhrdocumentsComponent extends PhrBaseListView implements OnInit {
  private patientService = null;

  constructor(appSvc: AppService, loginSvc: LoginService, private messageSvc: MessageService, navSvc: IceNavService, ptSvc: PatientService, router: Router) {
    super(appSvc, loginSvc, navSvc, ptSvc, router);
    this.patientService = ptSvc;

    let feaAccess = this.getPermission(userTypes.USER_FEATURES.ufExternalDocuments).default_access;
    this.nameOfView = "Documents";
    appSvc.defaultMenus();
    appSvc.addBreadcrumb(this.nameOfView, {}, true, "");

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      setTimeout(function () {
        messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    } else {
      this.dataViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufExternalDocuments);

      ptSvc.getPatientDocuments(appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient ? appSvc.getCurrentAccount() : appSvc.getCurrentPatient(), "", IceTypes.ACCOUNT_TYPE.actNone, "", "", "", "").subscribe(
        data => {
          this.refreshTableData(data);
        },
        error => {
        });
    }
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [
      new iceColumnDefinition("title", "Document", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("original_path", "Name of File", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("external_data_key", "external_data_key", true),
    ];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }

  isRowSelectionEnabled(): boolean {
    return true;
  }

  onMatGridRowClick(event) {
    if (event.rowData == null) {
      this.messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "An error occurred while downloading the document.");
      return;
    }

    this.patientService.downloadDocument(this.getAppService().getCurrentPatient(), event.rowData.external_data_key, event.rowData.parent_src_type);
  }
}
